import React from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { withInject } from '@piwikpro/platform';
import { RouterService } from '@piwikpro/router-crate';

interface Props {
  routerService: RouterService
}

const PPMS = ({ routerService }: Props) => (
  <>
    <RouterProvider router={routerService.getRouter()} />
    {process.env.NODE_ENV === 'development' && (
      <TanStackRouterDevtools router={routerService.getRouter()} position="bottom-right" />
    )}
  </>
);

export default withInject({
  routerService: 'RouterCrate.router',
})(PPMS);
